import React from "react";
import Select from "react-select";
import * as countryCodes from "country-codes-list";

const allCountryCodes = countryCodes.all();
export const countryCodeOptions = [
  {
    value: "+91",
    label: "+91 (IN)",
  },
  ...allCountryCodes
    .filter((c) => c.countryCallingCode !== "91")
    .map((c) => ({
      value: `+${c.countryCallingCode}`,
      label: `+${c.countryCallingCode} (${c.countryCode})`,
    })),
];
type Props = {
  label: string;
  fieldName: string; // e.g. "contact_mobile"
  codeFieldName: string; // e.g. "contact_country_code"
  vendor: any;
  setVendor: React.Dispatch<React.SetStateAction<any>>;
  errors: Record<string, string>;
  setErrors: React.Dispatch<React.SetStateAction<Record<string, string>>>;
  required?: boolean;
  disabled?: boolean;
};

const ContactNumberFieldWithCodes: React.FC<Props> = ({
  label,
  fieldName,
  codeFieldName,
  vendor,
  setVendor,
  errors,
  setErrors,
  required = false,
  disabled = false,
}) => {
  const countryCode = vendor.mail_detail?.[codeFieldName] || "";
  const number = vendor.mail_detail?.[fieldName] || "";

  const handleCountryCodeChange = (code: string) => {
    setVendor((prev: any) => ({
      ...prev,
      mail_detail: {
        ...prev.mail_detail,
        [codeFieldName]: code,
        [fieldName]: prev.mail_detail?.[fieldName] || "", // reset mobile when code changes
      },
    }));
    setErrors((prev) => ({ ...prev, [fieldName]: "" }));
  };

  const handleMobileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const num = e.target.value;

    // Validation
    if (!/^\d*$/.test(num)) return; // allow only digits
    if (countryCode === "+91" && num.length > 10) return; // max 10 for India

    setVendor((prev: any) => ({
      ...prev,
      mail_detail: {
        ...prev.mail_detail,
        [fieldName]: num,
      },
    }));

    if (countryCode === "+91") {
      setErrors((prev) => ({
        ...prev,
        [fieldName]:
          num.length === 10 ? "" : "Indian mobile number must be 10 digits",
      }));
    } else {
      setErrors((prev) => ({ ...prev, [fieldName]: "" }));
    }
  };

  return (
    <div className="grid gap-1">
      <label htmlFor={fieldName} className="text-sm">
        {label} {required && <span className="text-red-500">*</span>}
      </label>

      <div className="flex gap-2">
        {/* Country Code Dropdown */}
        <Select
          id={codeFieldName}
          name={codeFieldName}
          options={countryCodeOptions}
          value={
            countryCodeOptions.find((opt) => opt.value === countryCode) || null
          }
          onChange={(selected) =>
            handleCountryCodeChange(selected?.value || "")
          }
          isSearchable
          placeholder="+91"
        />

        {/* Mobile Input */}
        <input
          required={required}
          type="text"
          className="border rounded-md px-3 py-1 flex-grow"
          id={`mail_detail.${fieldName}`}
          name={`mail_detail.${fieldName}`}
          value={number}
          onChange={handleMobileChange}
          placeholder="Enter mobile number"
          disabled={!countryCode || disabled}
        />
      </div>

      {/* Hint  */}
      {!countryCode && (
        <p className="text-xs text-gray-500">
          Please select a country code first
        </p>
      )}

      {/* Error message */}
      {errors?.[fieldName] && (
        <p className="text-xs text-red-500">{errors[fieldName]}</p>
      )}
    </div>
  );
};

export default ContactNumberFieldWithCodes;
